(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kf-search-header-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kf-header-search')) {
    customElements.define('kf-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.shell = this.closest('page-header');
        this.input = this.querySelector('.kf-search__input');
        this.desktop = window.matchMedia('(min-width: 1200px)');
        const options = { signal: this.events.signal };
        this.shell.addEventListener('click', (event) => {
          if (!event.target.closest('.kf-search-toggle') || !this.desktop.matches) return;
          event.preventDefault();
          if (this.hidden) this.open();
          else this.close(true);
        }, options);
        this.querySelector('.kf-header-search__close').addEventListener('click', () => this.close(true), options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.hidden) {
            event.preventDefault();
            this.close(true);
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.hidden && !this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, options);
        const update = () => {
          if (!this.desktop.matches && !this.hidden) {
            const hadFocus = this.contains(document.activeElement);
            this.close();
            if (hadFocus) this.shell.querySelector('.kf-inline-search .kf-search__input')?.focus();
          } else if (!this.hidden) {
            this.updateHeight();
          }
        };
        window.addEventListener('resize', update, options);
        window.addEventListener('scroll', update, { ...options, passive: true });
        window.visualViewport?.addEventListener('resize', update, options);
      }

      get trigger() {
        return this.shell?.querySelector('.kf-search-toggle');
      }

      open() {
        if (!this.desktop.matches) return;
        this.shell.querySelectorAll('.kf-inline-search kf-search').forEach((search) => search.close?.());
        this.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.updateHeight();
        this.input.focus({ preventScroll: true });
      }

      updateHeight() {
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        this.style.setProperty('--kf-header-search-height', `${Math.max(0, bottom - this.getBoundingClientRect().top - 16)}px`);
      }

      close(restoreFocus = false) {
        this.hidden = true;
        this.querySelector('kf-search')?.close?.();
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger?.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.close();
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kf-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kf-search')) {
    customElements.define('kf-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.input = this.querySelector('.kf-search__input');
        this.form = this.querySelector('form');
        this.panel = this.querySelector('.kf-search__panel');
        this.results = this.querySelector('.kf-search__results');
        this.status = this.querySelector('.kf-search__status');
        this.all = this.querySelector('.kf-search__all');
        this.services = [...this.querySelectorAll('[data-kf-service-terms]')];
        try {
          this.categories = JSON.parse(this.querySelector('[data-kf-search-categories]')?.textContent || '[]');
        } catch {
          this.categories = [];
        }
        this.sequence = 0;
        const options = { signal: this.events.signal };
        this.input.addEventListener('input', (event) => {
          if (!event.isComposing && !this.composing) this.search();
        }, options);
        this.input.addEventListener('compositionstart', () => {
          this.composing = true;
          this.close();
        }, options);
        this.input.addEventListener('compositionend', () => {
          this.composing = false;
          this.search();
        }, options);
        this.input.addEventListener('focus', () => this.search(), options);
        this.form.addEventListener('submit', (event) => {
          this.input.value = this.normalizeTerm(this.input.value);
          if (!this.input.value || this.composing) {
            event.preventDefault();
          } else {
            const filteredUrl = this.colorCategoryUrl(this.input.value);
            if (filteredUrl) {
              event.preventDefault();
              location.assign(filteredUrl.href);
            }
          }
          this.close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            if (this.input !== document.activeElement) {
              this.suppressFocus = true;
              this.input.focus();
              this.suppressFocus = false;
            }
          }
          if (event.target === this.input && !this.panel.hidden && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
            const links = [...this.panel.querySelectorAll('a')].filter((el) => !el.hidden);
            event.preventDefault();
            (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
          }
        }, options);
        this.querySelector('.kf-search__dismiss').addEventListener('click', () => {
          this.close();
          this.suppressFocus = true;
          this.input.focus();
          this.suppressFocus = false;
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
      }

      disconnectedCallback() {
        this.close();
        this.events?.abort();
        this.events = null;
      }

      cancel() {
        this.sequence += 1;
        clearTimeout(this.timer);
        clearTimeout(this.deadline);
        this.request?.abort();
        this.request = null;
        this.results?.removeAttribute('aria-busy');
      }

      close() {
        this.cancel();
        if (!this.panel) return;
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.status.textContent = '';
      }

      message(text) {
        const paragraph = document.createElement('p');
        paragraph.className = 'kf-search__message';
        paragraph.textContent = text;
        this.results.replaceChildren(paragraph);
        this.status.textContent = text;
      }

      normalizeTerm(value) {
        const term = value.trim().replace(/\s+/g, ' ');
        // Keep explicit Shopify search syntax and quoted model names intact.
        if (/[":*()|]/.test(term) || /\b(?:AND|OR|NOT)\b/.test(term)) return term;
        return term
          .replace(/(^|\s)(?:strickpullis?|strickpullover|strick pullis?|strick pullover)(?=\s|$)/gi, '$1strick-pullover')
          .replace(/(^|\s)(?:karo|kariert(?:e|en|er|es)?|karo[ -]muster)(?=\s|$)/gi, '$1karomuster');
      }

      normalizeServiceTerm(value) {
        if (/[":*|]/.test(value)) return '';
        return value.toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/œ/g, 'oe').replace(/æ/g, 'ae')
          .replace(/[éèêë]/g, 'e').replace(/[àâá]/g, 'a').replace(/[òóô]/g, 'o').replace(/[ìíîï]/g, 'i').replace(/[ùúû]/g, 'u').replace(/ç/g, 'c').replace(/[ÿý]/g, 'y')
          .replace(/[-.,?!:;\/()'’&–—]/g, ' ').trim().replace(/\s+/g, ' ');
      }

      serviceNearMatch(query, keyword) {
        // Keep this bounded whole-phrase comparison in sync with kf-search-one-edit.
        if (query.length < 4 || query.length > 48 || keyword.length < 5 || keyword.length > 48 || Math.abs(query.length - keyword.length) > 1) return false;
        let prefix = 0;
        while (prefix < query.length && query[prefix] === keyword[prefix]) prefix++;
        if (query.length > keyword.length) return query.slice(prefix + 1) === keyword.slice(prefix);
        if (query.length < keyword.length) return query.slice(prefix) === keyword.slice(prefix + 1);
        return query.slice(prefix + 1) === keyword.slice(prefix + 1)
          || (query[prefix] === keyword[prefix + 1] && query[prefix + 1] === keyword[prefix] && query.slice(prefix + 2) === keyword.slice(prefix + 2));
      }

      matchingServices(term) {
        const normalized = this.normalizeServiceTerm(term);
        if (!normalized) return [];
        const phrase = ' ' + normalized + ' ';
        const entries = this.services.map((service) => ({ service, keywords: service.dataset.kfServiceTerms.split(',') }));
        const exact = entries.filter(({ keywords }) => keywords.some((keyword) => keyword && phrase.includes(' ' + keyword + ' ')));
        if (exact.length) return exact.map(({ service }) => service);
        const query = normalized.replace(/ /g, '');
        if (query.length < 4 || query.length > 48) return [];
        const compact = entries.map(({ service, keywords }) => ({ service, keywords: keywords.map((keyword) => keyword.replace(/ /g, '')).filter((keyword) => keyword.length >= 5 && keyword.length <= 48) }));
        const spacing = compact.filter(({ keywords }) => keywords.includes(query));
        if (spacing.length) return spacing.map(({ service }) => service);
        return compact.filter(({ keywords }) => keywords.some((keyword) => this.serviceNearMatch(query, keyword))).map(({ service }) => service);
      }

      colorCategoryUrl(term) {
        if (/[":*()|]/.test(term)) return null;
        const normalize = (value) => value.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/-/g, ' ').trim().replace(/\s+/g, ' ');
        const colors = [
          [/^(rot(?:e|en|er|es|em)?|red)$/, ['Red', 'Rot']],
          [/^(schwarz(?:e|en|er|es|em)?|black)$/, ['Black', 'Schwarz']],
          [/^(weiss(?:e|en|er|es|em)?|white)$/, ['White', 'Weiß', 'Weiss']],
          [/^(blau(?:e|en|er|es|em)?|blue)$/, ['Blue', 'Blau', 'blau', 'Navy']],
          [/^navy$/, ['Navy']],
          [/^(gruen(?:e|en|er|es|em)?|green)$/, ['Green', 'Grün', 'Grun']],
          [/^(braun(?:e|en|er|es|em)?|brown)$/, ['Brown', 'Braun']],
          [/^(grau(?:e|en|er|es|em)?|grey|gray)$/, ['Grey', 'Gray', 'Grau']],
          [/^(pink(?:e|en|er|es|em)?|rosa)$/, ['Pink', 'Rosa']],
          [/^(orange|orangen|oranger|oranges|orangem)$/, ['Orange']],
          [/^(beige|beigen|beiger|beiges|beigem)$/, ['Beige']],
          [/^(lila|violett(?:e|en|er|es|em)?|violet|purple)$/, ['Lila', 'Violet', 'Violett', 'Purple']]
        ];
        const words = normalize(term).split(' ');
        const matches = colors.filter(([pattern]) => words.some((word) => pattern.test(word)));
        if (matches.length !== 1) return null;
        const [pattern, values] = matches[0];
        const filler = new Set(['ich', 'suche', 'ein', 'eine', 'einen', 'bitte', 'in', 'der', 'die', 'das', 'farbe', 'fuer', 'damen']);
        const categoryTerm = words.filter((word) => !pattern.test(word) && !filler.has(word)).join(' ');
        const category = this.categories.find((entry) => entry.aliases.some((alias) => normalize(alias) === categoryTerm));
        if (!category) return null;
        const url = new URL(category.url, location.origin);
        if (url.origin !== location.origin) return null;
        values.forEach((value) => url.searchParams.append('filter.p.m.mm-google-shopping.color', value));
        return url;
      }

      search() {
        if (this.suppressFocus || this.composing) return;
        this.cancel();
        const term = this.normalizeTerm(this.input.value);
        if (!term) {
          this.results.replaceChildren();
          this.close();
          return;
        }
        const filteredUrl = this.colorCategoryUrl(term);
        const link = filteredUrl || new URL(this.form.action);
        if (!filteredUrl) link.searchParams.set('q', term);
        this.all.href = link.href;
        const visibleServices = this.matchingServices(term);
        this.services.forEach((service) => {
          service.hidden = !visibleServices.includes(service);
        });
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        if (visibleServices.length) {
          this.results.replaceChildren();
          this.status.textContent = visibleServices.map((service) => service.textContent).join(', ');
          return;
        }
        if (term.length < 2) {
          this.results.replaceChildren();
          return;
        }
        this.message(this.dataset.loading);
        this.results.setAttribute('aria-busy', 'true');
        const sequence = this.sequence;
        this.timer = setTimeout(async () => {
          const request = new AbortController();
          this.request = request;
          this.deadline = setTimeout(() => request.abort(), 8000);
          const url = filteredUrl ? new URL(filteredUrl) : new URL(this.dataset.endpoint, location.origin);
          url.searchParams.set('section_id', filteredUrl ? 'kf-filtered-search' : 'kf-predictive-search');
          if (!filteredUrl) {
            url.searchParams.set('q', term);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');
          }
          try {
            const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Search unavailable');
            const markup = await response.text();
            if (sequence !== this.sequence || !this.isConnected) return;
            const parsed = new DOMParser().parseFromString(markup, 'text/html');
            const list = parsed.querySelector('[data-kf-search-items]');
            if (!list) throw new Error('Search response incomplete');
            if (filteredUrl && list.dataset.kfColorFilter !== 'true' && list.dataset.kfResultCount !== '0') throw new Error('Color filter unavailable');
            const count = list.querySelectorAll('.kf-search__product').length;
            if (count) {
              this.results.replaceChildren(list);
              this.status.textContent = count + ' ' + this.dataset.resultsLabel;
            } else {
              this.message(this.dataset.empty);
            }
          } catch (error) {
            if (sequence === this.sequence && this.isConnected) this.message(this.dataset.error);
          } finally {
            if (sequence === this.sequence) {
              clearTimeout(this.deadline);
              this.request = null;
              this.results.removeAttribute('aria-busy');
            }
          }
        }, 250);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
